import * as React from "react";
import { FeatureDirectory } from "./FeatureDirectory";
import { FeatureAccordions } from "./FeatureAccordions";
import type { ProductAllFeaturesCategory } from "~/data/products/types";

interface AllFeaturesBodyProps {
  categories: ProductAllFeaturesCategory[];
  featureDetailsHeading: string;
  expandAllLabel: string;
  collapseAllLabel: string;
}

export function AllFeaturesBody({ categories, featureDetailsHeading, expandAllLabel, collapseAllLabel }: AllFeaturesBodyProps) {
  const [openItems, setOpenItems] = React.useState<string[]>(() => categories.map((c) => c.slug));

  function openItem(slug: string) {
    setOpenItems((current) => (current.includes(slug) ? current : [...current, slug]));
  }

  return (
    <>
      <FeatureDirectory categories={categories} onSelect={openItem} />
      <FeatureAccordions
        categories={categories}
        headingLabel={featureDetailsHeading}
        expandAllLabel={expandAllLabel}
        collapseAllLabel={collapseAllLabel}
        openItems={openItems}
        onOpenItemsChange={setOpenItems}
      />
    </>
  );
}
